module.exports = __webpack_public_path__ + "img/A - 03.e2eab338.png";